import React from 'react';
import { isUnidentifiedSpeaker } from './speakerHelper';
import PreviewArtworkBackground from './PreviewArtworkBackground';
import PreviewArtworkWaveform from './PreviewArtworkWaveform';
import FollowOutline from './FollowOutline';
import './PreviewFallbackImage.css';

const PreviewFallbackImage = ({ preview, speakerDescription, speakerDetailsId, foregroundImage, backgroundImage, circular, followed = false, alt, onError, onBackgroundError }) => {
  const speakerName = isUnidentifiedSpeaker(preview.person)
    ? (preview.source?.name?.trim() || 'Podcast')
    : preview.person.name.trim();

  return (
    <PreviewArtworkBackground className='previewFallbackImage' backgroundImage={backgroundImage} onBackgroundError={onBackgroundError}>
      <PreviewArtworkWaveform />
      <span className='previewFallbackIdentity'>
        <FollowOutline followed={followed} circular={circular}>
        <span className={`previewFallbackPortrait${circular ? '' : ' previewFallbackCover'}`}>
          {foregroundImage ? <img src={foregroundImage} alt={`${alt}${followed ? ', followed' : ''}`} loading='lazy' onError={onError} /> : <span aria-hidden='true'>{speakerName.charAt(0).toUpperCase()}</span>}
        </span>
        </FollowOutline>
        <span className='previewFallbackSpeaker' id={speakerDetailsId}>
          <span className='previewFallbackSpeakerName'>{speakerName}</span>
          {speakerDescription && <span className='previewFallbackSpeakerDescription'>{speakerDescription}</span>}
        </span>
      </span>
    </PreviewArtworkBackground>
  );
};

export default PreviewFallbackImage;
